import {useContext} from "react";
import ToasterContext from "@app/component/overlays/toaster/context/ToasterContext";

const useToaster = () => {
    return useContext(ToasterContext)
}

export default useToaster;